import devConfig from "./dev";
import prodConfig from "./prod";

const config = process.env.REACT_APP_ENV === "prod" ? prodConfig : devConfig;

export default config;
